import bg1 from '../assets/imgs/intro1.jpg';
import bg2 from '../assets/imgs/intro2.jpg';
import bg3 from '../assets/imgs/intro3.jpg';
import bg4 from '../assets/imgs/intro4.jpg';
import bg5 from '../assets/imgs/intro5.jpg';
import bg6 from '../assets/imgs/intro6.jpg';
import bg7 from '../assets/imgs/intro7.jpg';
import bg8 from '../assets/imgs/intro8.jpg';

import line1  from '../assets/audios/intro/intro1-1.mp4';
import line2  from '../assets/audios/intro/intro1-2.mp4';
import line3  from '../assets/audios/intro/intro2-1.mp4';
import line4  from '../assets/audios/intro/intro2-2.mp4';
import line5  from '../assets/audios/intro/intro3-1.mp4';
import line6  from '../assets/audios/intro/intro3-2.mp4';
import line7  from '../assets/audios/intro/intro4-1.mp4';
import line8  from '../assets/audios/intro/intro4-2.mp4';
import line9  from '../assets/audios/intro/intro5-1.mp4';
import line10 from '../assets/audios/intro/intro5-2.mp4';
import line11 from '../assets/audios/intro/intro6-1.mp4';
import line12 from '../assets/audios/intro/intro6-2.mp4';
import line13 from '../assets/audios/intro/intro7-1.mp4';
import line14 from '../assets/audios/intro/intro7-2.mp4';
import line15 from '../assets/audios/intro/intro8-1.mp4';
import line16 from '../assets/audios/intro/intro8-2.mp4';
import line17 from '../assets/audios/intro/intro8-3.mp4';
import line18 from '../assets/audios/intro/intro8-4.mp4';

export const introSlides = [
  { id: 1,  text: "Every case has an ending… neatly filed, stamped… and forgotten.",                 background: bg1, audio: line1  },
  { id: 2,  text: "At least… that’s what they say.", background: bg1, audio: line2  },

  { id: 3,  text: "Rows of names. Faces reduced to paper and ink.",        background: bg2, audio: line3  },
  { id: 4,  text: "Each one marked as finished… whether the truth was found… or not.",                 background: bg2, audio: line4  },

  { id: 5,  text: "But some stories don’t stay buried.",                                    background: bg3, audio: line5  },
  { id: 6,  text: "One file… refused to belong.",                                            background: bg3, audio: line6  },

  { id: 7,  text: "Dust gave way to fragments… scattered pieces of something unfinished.",            background: bg4, audio: line7  },
  { id: 8,  text: "Photographs. Reports. Clues that never aligned.",                 background: bg4, audio: line8  },

  { id: 9,  text: "And then… a name.",                   background: bg5, audio: line9  },
  { id: 10, text: "Not just any name… but one that should have brought this case to an end.",                                               background: bg5, audio: line10 },

  { id: 11, text: "It happened on a night no one could fully recall…",  background: bg6, audio: line11 },
  { id: 12, text: "A moment swallowed by shadows… where truth and silence became the same thing.",         background: bg6, audio: line12 },

  { id: 13, text: "When it was over… nothing made sense.",                                                  background: bg7, audio: line13 },
  { id: 14, text: "Nothing… except the mark that was left behind.",   background: bg7, audio: line14 },

  { id: 15, text: "The answers should have been simple.",                                   background: bg8, audio: line15 },
  { id: 16, text: "So the question was asked… why was it never closed?",          background: bg8, audio: line16 },
  { id: 17, text: "But instead of answers… There was only a warning.",  background: bg8, audio: line17 },
  { id: 18, text: "Some things… are better left untouched.",                                          background: bg8, audio: line18 },
];